import * as React from "react";
import { Mail, MailMessage, MailTemplate } from "../../classes/mail";
import theme from "../../style/theme";
import { Card, CardActionArea, CardContent, CardHeader, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ExpandableArea } from "../small-widgets";
import { useTranslation } from "react-i18next";

export default function RenderMail({ mail, isMobile, local=false, setSelected }:{mail:Mail, isMobile:boolean, local:boolean, setSelected:Function}) {
    document.documentElement.style.setProperty('--bg-color', theme.palette.primary.light);
    document.documentElement.style.setProperty('--bg-hover-color', theme.palette.primary.dark);

    const navigate = useNavigate();

    const [expandedTo, setExpandedTo] = React.useState(false);
    const [expandedAccepted, setExpandedAccepted] = React.useState(false);
    const [expandedPending, setExpandedPending] = React.useState(false);
    const [expandedRejected, setExpandedRejected] = React.useState(false);

    const handleOnClick = () => {
        if (local) {
            setSelected(mail);
        } else {
            navigate(`/mails/details?id=${mail.getId()}`);
        }
    }

    return <div style={{padding: 10}}>
        <Card className="mail-viwer">
            <CardActionArea className="card-margin" onClick={handleOnClick}>
                <CardHeader
                    title={<div>
                        <div className={isMobile ? "" : "expand-width"}>
                            <div>
                                <div className="mail-id">{mail.getId()}</div>
                                <div style={{fontSize: 8}}>{mail.getDelivery().getInfo().getMessageId()}</div>
                                <div style={{fontSize: 16}}>{mail.getDelivery().getState()}</div>
                            </div>
                            <div className="child-exp-all-width"/>
                            <div className="one-line" style={{fontSize: 13}}>
                                <div>{`Empezado: ${mail.getDelivery().getStartTime().toDate().toLocaleString('es-ES')}`}</div>
                                <div>{`Finalizado: ${mail.getDelivery().getEndTime().toDate().toLocaleString('es-ES')}`}</div>
                            </div>
                        </div>
                        <div style={{height: 10}}/>
                    </div>}
                />
            </CardActionArea>
            <Divider orientation="horizontal" flexItem/>
            <ExpandableArea expanded={expandedTo} setExpanded={setExpandedTo} title='Para' margin={true}>
                {mail.getTo().map((item, index) => <div key={index}>{item}</div>)}
            </ExpandableArea>
            <Divider orientation="horizontal" flexItem/>
            <CardActionArea className="card-margin" onClick={handleOnClick}>
                <CardContent>
                    <div style={{height: 10}}/>
                    <div>
                        {`Intentos: ${mail.getDelivery().getAttemps()}`}
                    </div>
                    {mail.getDelivery().getError() != null && mail.getDelivery().getError() != undefined && mail.getDelivery().getError() != ""
                        ? <div className="expand-width">
                            <div>Error: &nbsp;</div>
                            <div>{mail.getDelivery().getError()}</div>
                        </div>
                        : null
                    }
                    <div className="expand-width">
                        <div>Respuesta del servidor: &nbsp;</div>
                        <div>{mail.getDelivery().getInfo().getResponse()}</div>
                    </div>
                </CardContent>
                <div style={{height: 10}}/>
            </CardActionArea>
            <Divider orientation="horizontal" flexItem/>
            {mail.getDelivery().getInfo().getAccepted().length != 0
                ? <>
                    <ExpandableArea expanded={expandedAccepted} setExpanded={setExpandedAccepted} title='Aceptados' margin={true}>
                        {mail.getDelivery().getInfo().getAccepted().map((item, index) => <div key={index}>{item}</div>)}
                    </ExpandableArea>
                    <Divider orientation="horizontal" flexItem/>
                </>
                : null
            }
            {mail.getDelivery().getInfo().getPending().length != 0
                ? <>
                    <ExpandableArea expanded={expandedPending} setExpanded={setExpandedPending} title='Aceptados' margin={true}>
                        {mail.getDelivery().getInfo().getPending().map((item, index) => <div key={index}>{item}</div>)}
                    </ExpandableArea>
                    <Divider orientation="horizontal" flexItem/>
                </>
                : null
            }
            {mail.getDelivery().getInfo().getRejected().length != 0
                ? <>
                    <ExpandableArea expanded={expandedRejected} setExpanded={setExpandedRejected} title='Aceptados' margin={true}>
                        {mail.getDelivery().getInfo().getRejected().map((item, index) => <div key={index}>{item}</div>)}
                    </ExpandableArea>
                    <Divider orientation="horizontal" flexItem/>
                </>
                : null
            }
            <CardActionArea className="card-margin" onClick={handleOnClick}>
                <CardContent>
                    <div style={{height: 10}}/>
                    {mail.getTemplate() != null && mail.getTemplate() != undefined
                        ? <TemplateDetails template={mail.getTemplate()}/>
                        : null
                    }
                    {mail.getMessage() != null && mail.getMessage() != undefined
                        ? <MessageDetails message={mail.getMessage()}/>
                        : null
                    }
                </CardContent>
            </CardActionArea>
        </Card>
    </div>;
}

export function TemplateDetails({template}:{template:MailTemplate}) {
    const { t } = useTranslation();

    return <div style={{fontSize: 14}}>
        <div style={{fontSize: 18}}>{t('mails.details.template.title')}</div>
        <Divider orientation="horizontal" flexItem/>
        <div style={{height: 5}}/>
        <div>{t('mails.details.template.name')}: {template.getName()}</div>
        <Divider orientation="horizontal" flexItem sx={{height:'5px'}}/>
        <div className="expand-width">
            <div style={{width: '10px'}}/>
            <div>
                {[...template.getData().keys()].map((key) => <div key={key}>{key}: {template.getData().get(key)}</div>)}
            </div>
        </div>
        <div style={{height: 10}}/>
    </div>
}

export function MessageDetails({message}:{message:MailMessage}) {
    const { t } = useTranslation();

    return <div style={{fontSize: 14}}>
        <div style={{fontSize: 18}}>{t('mails.details.message.title')}</div>
        <Divider orientation="horizontal" flexItem/>
        <div style={{height: 5}}/>
        <div>{t('mails.details.message.subject')}: {message.getSubject()}</div>
        <Divider orientation="horizontal" flexItem sx={{height:'5px'}}/>
        <div className="expand-width">
            <div>{t('mails.details.message.text')}: &nbsp;</div>
            <div>{message.getText()}</div>
        </div>
        <div className="expand-width">
            <div>{t('mails.details.message.html')}: &nbsp;</div>
            <div>{message.getHtml()}</div>
        </div>
        <div style={{height: 10}}/>
    </div>
}